export default __webpack_public_path__ + "assets/e8da2532f0149b2393a3688eee7e4266.png";